"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StaticInitializers_1 = require("./StaticInitializers");
/** TODO: time formatting is in localization specific domain.
 * Once we have a framework for localization this code should move there**/
var TimeHhMm = /** @class */ (function () {
    function TimeHhMm(hour, minute) {
        TimeHhMm.throwOnInvalidHourOrMinute(hour, minute);
        this.hour = hour;
        this.minute = minute;
    }
    TimeHhMm.prototype.toHHMMString = function () {
        return TimeHhMm.toHHMMString(this.hour, this.minute);
    };
    TimeHhMm.prototype.toNumber = function () {
        return TimeHhMm.toNumber(this);
    };
    TimeHhMm.fromHHMMString = function (hhMM) {
        if (!/^\d{1,2}:\d{1,2}$/.test(hhMM)) {
            throw hhMM + ' should match hh:mm format';
        }
        var hhMMArr = hhMM.split(':');
        var hh = parseInt(hhMMArr[0], 10);
        var mm = parseInt(hhMMArr[1], 10);
        TimeHhMm.throwOnInvalidHourOrMinute(hh, mm);
        return new TimeHhMm(hh, mm);
    };
    TimeHhMm.fromNumber = function (minutesInADay) {
        if (minutesInADay < 0 || minutesInADay % 1 !== 0 || minutesInADay > StaticInitializers_1.StaticInitializers.MINUTES_IN_DAY) {
            throw minutesInADay + ' should be a number in [0, ' + StaticInitializers_1.StaticInitializers.MINUTES_IN_DAY + '] range.';
        }
        return new TimeHhMm(Math.floor(minutesInADay / 60), minutesInADay % 60);
    };
    TimeHhMm.toNumber = function (time) {
        return time.hour * 60 + time.minute;
    };
    TimeHhMm.toHHMMString = function (hour, minute) {
        TimeHhMm.throwOnInvalidHourOrMinute(hour, minute);
        var hourStr = hour + '';
        if (hour < 10) {
            hourStr = '0' + hourStr;
        }
        var minuteStr = minute + '';
        if (minute < 10) {
            minuteStr = '0' + minuteStr;
        }
        return hourStr + ':' + minuteStr;
    };
    TimeHhMm.throwOnInvalidHourOrMinute = function (hour, minute) {
        if (hour >= StaticInitializers_1.StaticInitializers.HOURS_IN_DAY || hour % 1 !== 0 || hour < 0) {
            throw new Error("Invalid hour, should be in [0-" + StaticInitializers_1.StaticInitializers.HOURS_IN_DAY + "] range");
        }
        if (minute >= StaticInitializers_1.StaticInitializers.MINUTES_IN_HOUR || minute % 1 !== 0 || minute < 0) {
            throw new Error("Invalid minute, should be in [0-" + StaticInitializers_1.StaticInitializers.MINUTES_IN_HOUR + "] range.");
        }
    };
    TimeHhMm.prototype.equals = function (other) {
        var otherTime = other;
        if (otherTime && otherTime.hour !== undefined && otherTime.minute !== undefined) {
            return otherTime.hour === this.hour && otherTime.minute === this.minute;
        }
        return this === other;
    };
    return TimeHhMm;
}());
exports.TimeHhMm = TimeHhMm;
//# sourceMappingURL=TimeHhMm.js.map